import { render, staticRenderFns } from "./FieldTypeUrl.vue?vue&type=template&id=06df309b&"
import script from "./FieldTypeUrl.vue?vue&type=script&lang=ts&"
export * from "./FieldTypeUrl.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports